var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card bg-dark text-white",on:{"click":function($event){return _vm.goTo(_vm.link)}}},[_c('div',{staticClass:"imageContainer"},[_c('img',{staticClass:"card-img",attrs:{"src":_vm.image,"alt":"..."}})]),_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }